export enum ReceiveType {
  DELIVERY,
  TABLES,
  PICKUP,
}
